import { Injectable, inject, signal } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { translate } from '@jsverse/transloco';

/**
 * Дали в момента върви групово изпращане. Диалогът го вдига, докато цикълът
 * работи или е на пауза; guard-ът на маршрутите го чете.
 */
@Injectable({ providedIn: 'root' })
export class StatementSendActivity {
  readonly busy = signal(false);
}

/**
 * Предупреждава при напускане на екрана по време на изпращане (#234): цикълът
 * живее в браузъра и спира заедно с екрана. Неизпратените остават чернови.
 */
export const statementSendGuard: CanDeactivateFn<unknown> = () => {
  if (!inject(StatementSendActivity).busy()) return true;
  return window.confirm(translate('statements.sendDialog.leaveWarning'));
};
